var _g, _path, _circle, _circle2, _circle3, _circle4, _circle5, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_1292_3077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7902 37.6896C12.7902 25.3645 22.7816 15.373 35.1067 15.373C47.4318 15.373 57.4232 25.3645 57.4232 37.6896V61.7461H12.7902V37.6896Z",
    fill: "url(#paint0_linear_1292_3077)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07898 67.8828C8.07898 63.4645 11.6607 59.8828 16.079 59.8828H54.1346C58.5529 59.8828 62.1346 63.4645 62.1346 67.8828V68.5825C62.1346 69.6871 61.2392 70.5825 60.1346 70.5825H10.079C8.97441 70.5825 8.07898 69.6871 8.07898 68.5825V67.8828Z",
    fill: "url(#paint1_linear_1292_3077)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1067,
    cy: 3.36585,
    r: 3.36585,
    fill: "#F0545D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0769,
    cy: 10.3756,
    r: 3.36585,
    fill: "#FFB8BC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8477,
    cy: 27.733,
    r: 3.36585,
    fill: "#F0545D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1366,
    cy: 10.3756,
    r: 3.36585,
    fill: "#FFB8BC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.36585,
    cy: 27.733,
    r: 3.36585,
    fill: "#F0545D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1292_3077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3382 44.2023H32.8852L32.399 28.4785H37.8244L37.3382 44.2023ZM32.2774 48.589C32.27 48.0881 32.3916 47.624 32.6421 47.1967C32.8999 46.7621 33.2461 46.4196 33.6807 46.1691C34.1227 45.9187 34.5979 45.7934 35.1061 45.7934C35.5997 45.7934 36.0638 45.9223 36.4984 46.1802C36.933 46.4306 37.2793 46.7695 37.5371 47.1967C37.8023 47.624 37.9349 48.0881 37.9349 48.589C37.9349 49.0973 37.8023 49.5688 37.5371 50.0034C37.2793 50.438 36.933 50.7842 36.4984 51.0421C36.0638 51.2925 35.5997 51.4177 35.1061 51.4177C34.5905 51.4177 34.1154 51.2925 33.6807 51.0421C33.2461 50.7842 32.8999 50.4417 32.6421 50.0144C32.3916 49.5798 32.27 49.1047 32.2774 48.589Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_1292_3077",
    x: 8.79016,
    y: 11.373,
    width: 50.6331,
    height: 54.373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.548568 0 0 0 0 0.144856 0 0 0 0 0.168147 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1292_3077"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.761621 0 0 0 0 0.775374 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1292_3077",
    result: "effect2_innerShadow_1292_3077"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.984245 0 0 0 0 0.488486 0 0 0 0 0.815687 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1292_3077",
    result: "effect3_innerShadow_1292_3077"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1292_3077",
    x: 28.2771,
    y: 26.4785,
    width: 21.6578,
    height: 38.9392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.315706 0 0 0 0 0.0202249 0 0 0 0 0.0202249 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1292_3077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1292_3077",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1292_3077",
    x1: 35.1067,
    y1: 15.373,
    x2: 35.1067,
    y2: 61.7461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0545D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6202A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1292_3077",
    x1: 35.1068,
    y1: 59.8828,
    x2: 35.1068,
    y2: 70.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241D3B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertImg);
export default __webpack_public_path__ + "static/media/alert-img.18a9a15d351ca659c2a1cc64dfb2d698.svg";
export { ForwardRef as ReactComponent };